import { createFileRoute } from "@tanstack/react-router";
import { QuestionBankScreen } from "@modules/competencies/views";
import { requireSurface } from "../-guards";

// /staff/questions — « Banque de questions », E10's second surface.
//
// Guarded on `round_configuration` like the rest of the staff tree: the bank is part of the method
// the foundation configures, so it belongs to the same surface as round configuration rather than
// to a permission of its own.
export const Route = createFileRoute("/staff/questions")({
  beforeLoad: ({ context, location }) =>
    requireSurface(
      context.queryClient,
      "round_configuration",
      location.pathname
    ),
  component: QuestionBankScreen,
});
